import { AppErrorBoundary } from '@repo/monitoring';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Suspense } from 'react';
import { Provider } from 'react-redux';

import { ErrorDisplay } from '@repo/ui';
import { Layout, Spinfinity } from 'components';
import ImpersonationProvider from 'providers/ImpersonationProvider';
import store from 'store/store';
import { AnalyticsProvider } from './contexts/analytics/AnalyticsProvider';

import { ENVIRONMENT, FAVICON, SEGMENT_WRITE_KEY } from 'assets/env_constants';

import 'assets/scss/style.scss';
import 'react-toastify/dist/ReactToastify.min.css';

// Force deployment again

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 3600000,
    },
  },
});
if (window) {
  window.queryClient = queryClient;
}

const updateFavicon = () => {
  const favicon = document.querySelector('link[rel="icon"]') as HTMLLinkElement;
  if (favicon) {
    favicon.href = FAVICON;
  }
};

const App = () => {
  updateFavicon();
  return (
    <AppErrorBoundary
      componentName='results-portal'
      fallback={({ error, resetError }) => (
        <ErrorDisplay
          error={error}
          reset={resetError}
          onReload={() => {
            resetError();
            window.location.reload();
          }}
          environment={ENVIRONMENT}
          description='Please refresh your screen. If you continue to see an error, reach out to hello@tinyhealth.com'
        />
      )}
      sentryTags={{
        app: 'results-portal',
      }}
    >
      <Provider store={store}>
        <QueryClientProvider client={queryClient}>
          <ImpersonationProvider>
            <AnalyticsProvider
              writeKey={
                ((ENVIRONMENT === 'production' || ENVIRONMENT === 'preview') &&
                  SEGMENT_WRITE_KEY) ||
                ''
              }
            >
              <Suspense
                fallback={
                  <div
                    style={{
                      width: '100%',
                      height: '100vh',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <Spinfinity />
                  </div>
                }
              >
                <Layout />
              </Suspense>
            </AnalyticsProvider>
          </ImpersonationProvider>
          {/* <ReactQueryDevtools initialIsOpen={false} /> */}
        </QueryClientProvider>
      </Provider>
    </AppErrorBoundary>
  );
};

export default App;
